// ============================================================================
// teamMemberOrder — lien vers la fiche et ordre d'affichage de la carte de
// membre compacte (TeamMemberCard), hors du fichier de composants (fast refresh)
// ============================================================================

import type { RosterMember } from '../../hooks/useMonEquipe';

/** Destination de la fiche — la meme pour les deux ecrans. */
export function memberProfileHref(email: string, teamId: string | null): string {
  const params = new URLSearchParams({ tab: 'gestion', from: 'mon-equipe' });
  if (teamId) params.set('fromTeam', teamId);
  return `/profile/${encodeURIComponent(email)}?${params.toString()}`;
}

/** Rang d'affichage : la direction de l'equipe en tete, puis les gestionnaires. */
function leadershipRank(member: RosterMember): number {
  if (member.isDirector) return 0;
  if (member.orgLevel === 'gestionnaire') return 1;
  return 2;
}

/** Tri stable : l'ordre du serveur est garde a rang egal. */
export function orderLeadersFirst(roster: readonly RosterMember[]): RosterMember[] {
  return roster
    .map((member, index) => ({ member, index }))
    .sort((a, b) => leadershipRank(a.member) - leadershipRank(b.member) || a.index - b.index)
    .map(({ member }) => member);
}
